import DOMPurify from 'dompurify';
import { Icon } from '../models/icon';

export function sanitizeSvg(svg: string): string {
  return svg ? DOMPurify.sanitize(svg, { USE_PROFILES: { svg: true, svgFilters: true } }) : svg;
}

export function sanitizeIcons(icons: Icon[]): Icon[] {
  return (icons ?? []).map(icon => ({ ...icon, Content: sanitizeSvg(icon.Content) }));
}
